












































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { AccountService } from '@/core/services';
import { ProgramOverviewImageDialogCpt, GreetingMessageCpt } from '@/core/components';
import { images } from '@/core/constants';
import AppVue from '../AppVue.vue';

@Component({
  components: {
    ProgramOverviewImageDialogCpt,
    GreetingMessageCpt,
  },
})
export default class HomeView extends AppVue {
  isAttendanceRecorded = false;
  showImageDialog = false;

  async created() {
    this.isAttendanceRecorded = await AccountService.isAttendanceRecorded();
  }

  get programOverviewImgUrl() {
    return images.programOverview;
  }

  get preReadingImgUrl() {
    return images.preReadingImgUrl;
  }

  get workshopTemplatesImgUrl() {
    return images.workshopTemplatesImgUrl;
  }

  get workshopMaterialsImgUrl() {
    return images.workshopMaterialsImgUrl;
  }

  get strategyClarificationWorkshopImgUrl() {
    return images.strategyClarificationWorkshopImgUrl;
  }

  get criticalSkillsWorkshopImgUrl() {
    return images.criticalSkillsWorkshopImgUrl;
  }

  get programmeGuideImgUrl() {
    return images.programmeGuideImgUrl;
  }

  get preReading() {
    return require('@/styles/files/So-you-think-you-have-a-strategy PRE READING.pdf');
  }

  get workshopTemplates() {
    return require('@/styles/files/SOS Workshop 2 Templates.pdf');
  }

  get criticalSkillsWorkshop() {
    return require('@/styles/files/SOS Critical Skills WS.pdf');
  }

  get workshopMaterials() {
    return require('@/styles/files/SOS Slide Deck for App.pptx');
  }

  get strategyClarificationWorkshop() {
    return require('@/styles/files/SOS Strategy Clarification Workshop 2.pdf');
  }

  get programmeGuide() {
    return require('@/styles/files/Spotlight on Skills Participant Guide.pdf');
  }
}
